import { create } from 'zustand';

interface CollectionsRailState {
  /** Hides the collections rail so the files pane gets the full width. */
  isCollapsed: boolean;
}

/**
 * Whether the collections rail is showing.
 *
 * Held outside the component tree because the toggle sits in the pane header
 * while the rail it hides is the pane's sibling, and because the workspace
 * remounts the pane by `key` on every collection switch — state inside it
 * would forget the rail was closed each time the user picks another
 * collection.
 */
export const useCollectionsRailStore = create<CollectionsRailState>(() => ({
  isCollapsed: false,
}));

export const useIsCollectionsRailCollapsed = (): boolean =>
  useCollectionsRailStore((state) => state.isCollapsed);

export const toggleCollectionsRail = (): void => {
  useCollectionsRailStore.setState((state) => ({ isCollapsed: !state.isCollapsed }));
};
